import axios, { type AxiosResponse } from '@fs/zion-axios'
import { STANDARDS_SERVICE as SERVICE } from '../../serviceNames'

const BASE = `${SERVICE}/place/ws/places/request`

export const getPlaces = async (params?: Record<string, unknown>): Promise<AxiosResponse> => {
  return axios.get(`${BASE}`, { params })
}
